"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var a = function a(e, r, o) {
  var i = e,
      n = r.trim().split(".");

  for (var t = 0; t < n.length; t += 1) {
    t !== n.length - 1 ? (i[n[t]] || (i[n[t]] = {}), i = i[n[t]]) : i[n[t]] = o;
  }
};

var c = function c() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var r = arguments.length > 1 ? arguments[1] : undefined;
  var o = arguments.length > 2 ? arguments[2] : undefined;
  var i = arguments.length > 3 ? arguments[3] : undefined;
  var n = arguments.length > 4 ? arguments[4] : undefined;
  var t = arguments.length > 5 ? arguments[5] : undefined;

  if (o) {
    if (process.env.NODE_ENV === "production") return o;

    if (process.env.NODE_ENV !== "production") {
      if (o && e.includes(o) || o && t && t.includes(o) || n === "confirm") return o;
      throw new Error("Invalid color given (".concat(o, ") / unsupported by ").concat(i, " component \"").concat(r, "\". Options include: ").concat(e.join(", ")));
    }
  }
},
    l = exports.c = function () {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  return {
    shouldForwardProp: function shouldForwardProp(r, o) {
      return !e.includes(r) && o(r);
    }
  };
};

var _styledcomponents = require('styled-components');

var p = "200ms ease",
    x = exports.e = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    transition: all ", ";\n"])), p),
    u = exports.f = function () {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }

  return _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    transition: ", ";\n"])), e.map(function (r) {
    return "".concat(r, " ").concat(p);
  }).join(", "));
};

var g = function g(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

var E = function E(e) {
  e.preventDefault();
};

var O = typeof window < "u" && typeof document < "u";
exports.a = a;
exports.b = c;
exports.c = l;
exports.d = p;
exports.e = x;
exports.f = u;
exports.g = g;
exports.h = E;
exports.i = O;